<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('crs.quantityTask.dicesDetailList')"
    :close-on-click-modal="false"
    :before-close="closePop"
    :close-on-press-escape="false"
    width="70%"
  >
    <el-table border v-if="tableData" :data="tableData">
      <el-table-column v-for="item in tableNav" :label="item.title" :prop="item.id"></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="pageSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Url from '@/views/crs/util/url'
let types = { 0: '獲取', 1: '消耗' }

export default {
  props: ['dicesData', 'isShow'],
  components: {
    tablePage
  },
  data() {
    return {
      visible: this.isShow,
      pageData: {
        selection: true,
        sequence: true,
        queryUrl: Url.quantityTask.activity.dicesDetail + '?customerNumber=' + this.dicesData.customerNumber + '&actId=' + this.dicesData.actId + '&businessTypeAlias=' + DateUtil.getParamKey(this.$route.params),
        cols: [
          {
            title: '時間', field: 'ctime'},
          { title: '賬號', field: 'customerNumber' },
          { title: '活動ID', field: 'actId' },
          { title: '塞子數', field: 'quantity' },
          { title: '關卡', field: 'level' },
          { title: '類型', field: 'type' }
        ]
      },
      tableNav: [
        { title: '時間', id: 'ctime' },
        { title: '賬號', id: 'customerNumber' },
        { title: '活動ID', id: 'actId' },
        { title: '塞子數', id: 'quantity' },
        { title: '關卡', id: 'level' },
        { title: '類型', id: 'type' }
      ],
      tableData: [],
      totalNum: 0,  //当前资源条数
      currentPage: 1,  //当前页数
      pageSize: 50 //当前页条数数
    }
  },
  methods: {
    closePop() {
      this.visible = false
      this.$emit('changePop', this.visible)
    },
    getDetail(data) {
      this.$axios.get(Url.quantityTask.activity.dicesDetail + '?customerNumber=' + this.dicesData.customerNumber + '&actId=' + this.dicesData.actId + '&businessTypeAlias=' + DateUtil.getParamKey(this.$route.params) + data).then(res => {
        if (res.code == 0) {
          if (res.result.list) {
            for (const i in res.result.list) {
              res.result.list[i].ctime = DateUtil.formatDate(res.result.list[i].ctime, 'yyyy-MM-dd hh:mm:ss')
              res.result.list[i].type = types[res.result.list[i].type]
            }
            this.tableData = res.result.list
            this.totalNum = res.result.total
          } else {
            this.tableData = []
            this.totalNum = 0
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    initDetail() {
      let data = '&pageNum= ' + this.currentPage + '&pageSize=' + this.pageSize + ''
      this.getDetail(data)
    },
    /*切换分页条数*/
    pageSizeChange(val) {
      this.pageSize = val
      let data = '&pageNum= ' + this.currentPage + '&pageSize=' + val + ''
      this.getDetail(data)
    },
    /*切换当前页*/
    currentChange(val) {
      this.currentPage = val
      let data = '&pageNum= ' + val + '&pageSize=' + this.pageSize + ''
      this.getDetail(data)
    }
  },
  mounted() {
    this.initDetail()
  }
}
</script>
